import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Acm } from "app/models/loyalty-acm.model";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { FormFields } from "app/views/campaign-3/components/form-fields/form-fields.component";
import { Accumulator3Service } from "app/views/campaign-3/services/accumulator3.service";
import { AcmChannel, Campaign3TestService } from "app/views/campaign-3/services/campaign3testservice";




interface FieldModel {

  start_date: Date | null;
  end_date: Date | null;
  date_pti_start: Date | null;
  date_pti_end: Date | null;
  flg_ext_circ: boolean | null;
  channel: any | null;
}

@Component({
  selector: 'app-acm-channel-edit-3',
  templateUrl: './acm-channel-edit-3.component.html',
  styleUrls: ['./acm-channel-edit-3.component.css']
})

export class AcmChannelEdit3Component implements OnInit {

  @Input() acmLoyChannel: AcmChannel;
  @Input() listChannel;
  @Input() fatherAcmChannel: Acm;
  @Output() refreshPage = new EventEmitter();
  @Output() closeEditPopup = new EventEmitter<any>();

  @ViewChild('start_date') startDate: FormFields;
  @ViewChild('end_date') endDate: FormFields;
  @ViewChild('date_pti_start') datePtiStart: FormFields;
  @ViewChild('date_pti_end') datePtiEnd: FormFields;
  @ViewChild('flg_ext_circ') flgExtCirc: FormFields;
  @ViewChild('acm_channel') channel: FormFields;

  popupError: boolean = false;
  dateOrderError: boolean = false;
  dateOrderMessage: string = "*End date minore di StartDate"

  dateOrderAccError: boolean = false;
  dateOrderAccMessage: string = "*EndAccDate minore di StartAccDate"

  missingChannel: boolean = false;
  missingChannelMessage: string = "Selezionare almeno un canale"

  dateformat = 'yyyy-MM-dd';



  editFieldModel: FieldModel = {

    start_date: null,
    end_date: null,
    date_pti_start: null,
    date_pti_end: null,
    flg_ext_circ: null,
    channel: null
  };

  errors = {
    acmDescription: false,
    start_date: false,
    end_date: false,
    date_pti_start: false,
    date_pti_end: false,
    flg_ext_circ: false,
    channel: false
  };

  ngOnInit(): void {

    console.log(this.fatherAcmChannel)
    console.log(this.acmLoyChannel);


    if (this.acmLoyChannel) {
      this.editFieldModel = {
        start_date: new Date(this.acmLoyChannel.date_start) || null,
        end_date: new Date(this.acmLoyChannel.date_end) || null,
        date_pti_start: new Date(this.acmLoyChannel.date_pti_start) || null,
        date_pti_end: new Date(this.acmLoyChannel.date_pti_end) || null,
        flg_ext_circ: this.acmLoyChannel.flg_ext_circ === '1',
        channel: this.listChannel.find(x => x.value == this.acmLoyChannel.channel_id) || null
      };

      console.log(this.editFieldModel);
    }
  }

  constructor(
    public testService: Campaign3TestService,
    private accService: Accumulator3Service,
    public srvCalendar: CalendarTranslateService,
    private datePipe: DatePipe) {
  }

  OnSaveEntity() {
    this.dateOrderError = false;
    this.dateOrderAccError = false;
    this.missingChannel = false;
    this.startDate.performValidation();
    this.endDate.performValidation();
    this.datePtiStart.performValidation();
    this.datePtiEnd.performValidation();




    //  this.channel.performValidation();


    this.validateFields();

    // Verifico se oggetto error ha dei parametri settati a true
    const errorValues = Object.keys(this.errors).map(key => this.errors[key]);
    const hasErrors = errorValues.some(error => error);
    console.log(hasErrors);
    // Se ci sono errori, non salvare l'entità e aprire popup
    if (hasErrors) {
      console.log("abort saving, there are some errors", this.editFieldModel);
      this.popupError = true;

      for (const key in this.errors) {
        if (Object.prototype.hasOwnProperty.call(this.errors, key)) {
          this.errors[key] = false;

        }
      }
      return;
    }
    let editedAcmChannel = new AcmChannel();


    editedAcmChannel.acm_id = parseInt(this.fatherAcmChannel.id);
    editedAcmChannel.date_start = this.datePipe.transform(this.editFieldModel.start_date, this.dateformat);
    editedAcmChannel.date_end = this.datePipe.transform(this.editFieldModel.end_date, this.dateformat);

    editedAcmChannel.date_pti_start = this.datePipe.transform(this.editFieldModel.date_pti_start, this.dateformat);
    editedAcmChannel.date_pti_end = this.datePipe.transform(this.editFieldModel.date_pti_end, this.dateformat);
    editedAcmChannel.flg_ext_circ = this.editFieldModel.flg_ext_circ ? "1" : "0";
    editedAcmChannel.channel_id = this.listChannel.find(x => x.value == this.editFieldModel.channel.value).value;


    this.accService.editAcmLoyChannel(editedAcmChannel).subscribe(res => {
      console.log(res);
      this.refreshPage.emit(this.fatherAcmChannel);
      this.closeEditPopup.emit();
    });

  }
  onClosePopup(){
    this.closeEditPopup.emit();
  }

  onChangeStartDate(date: Date) {
    this.editFieldModel.start_date = date;
  }
  onChangeStartAccDate(date: Date) {
    this.editFieldModel.date_pti_start = date;
  }
  onChangeEndDate(date: Date) {
    this.editFieldModel.end_date = date;
  }
  onChangeEndAccDate(date: Date) {
    this.editFieldModel.date_pti_end = date;
  }
  validateFields() {
    // Controllo per ciascun campo
    for (const field in this.editFieldModel) {
      if (field === 'flg_ext_circ') {
        continue; // Salta il controllo per flg_ext_circ perchè può essere nullo
      }
      if (!this.editFieldModel[field]) {
        this.errors[field] = true;
      } else {
        this.errors[field] = false;
      }
    }

    // Controllo della relazione tra start_date e end_date
    if (this.editFieldModel.start_date && this.editFieldModel.end_date) {
      const startDate = new Date(this.editFieldModel.start_date);
      const endDate = new Date(this.editFieldModel.end_date);
      if (startDate > endDate) {
        this.errors.start_date = true;
        this.errors.end_date = true;
        this.dateOrderError = true;

      }
    }
    if (this.editFieldModel.date_pti_start && this.editFieldModel.date_pti_end) {
      const startDate = new Date(this.editFieldModel.date_pti_start);
      const endDate = new Date(this.editFieldModel.date_pti_end);
      if (startDate > endDate) {
        this.errors.date_pti_start = true;
        this.errors.date_pti_end = true;
        this.dateOrderAccError = true;
      }
    }
    if (!this.editFieldModel.channel) {
      this.missingChannel = true;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/acm-channel-edit-3/acm-channel-edit-3.component.ts